import _ from 'underscore';
import $ from 'jquery';
import Promise from 'bluebird';
import ko from 'knockout';
import React from 'react';
import ReactDOM from 'react-dom';
import { cloneDeep } from '@bingads-webui-universal/primitive-utilities';
import {
  CompanyNameCriterionSetting,
  JobFunctionCriterionSetting,
  IndustryCriterionSetting,
  AgeCriterionSetting,
  DeviceCriterionSetting,
  GenderCriterionSetting,
  AudienceCriterionSetting,
  LocationCriterionSetting
} from '@bingads-webui-campaign/audience-criterion-setting';
import { BackboneSchema as backboneSchema } from '@bingads-webui/backbone-schema';
import { InputControl } from '@bingads-webui/input-control';
import { DependencyResolver } from '@bingads-webui-campaign/dependency-resolver';
import {
  AudienceCampaignErrorsView,
  AudienceStepBase,
  criterionHelper,
  getBidSchema,
  getBulkErrorsLogMessage,
  BidStrategy,
  CampaignSubTypes,
  getCampaignType,
  PricingModelToRangeKey,
  getFeedInfo,
  DefaultBidCPVWarningThreshold,
  BiddingStrategyValueToRecommendBidKey,
} from '@bingads-webui-campaign/audience-campaign-shared';
import { shouldSupportCashbackSettings } from '@bingads-webui-campaign/personalized-offer-shared';
import { EstimateRequestFactory } from '@bingads-webui-campaign/reach-estimate-control';
import { withUiBlock } from '@bingads-webui/uiblocker';
import { Alert } from '@bingads-webui-react/alert';
import { GoalSelectorView } from '@bingads-webui-campaign-react/goal-selector';
import BiddingStrategyView from '@bingads-webui-campaign-legacy/bidding-strategy/view/setting';
import { FrequencyCapping } from '@bingads-webui-campaign/frequency-capping';
import template from './template.pug';
import { KPIEstimateReact } from './kpi-estimate-react';
import { BidStrategyReact } from './bid-strategy-react';

/**
 * CrudAudienceBudgetBid class that extends {AudienceStepBase} class
 * The class defines the section of the setting budget and bid
 *
 * @class CrudAudienceBudgetBid
 * @extends {AudienceStepBase}
 */
export class CrudAudienceBudgetBid extends AudienceStepBase {
  initialize(options = {}) {
    this.renderMarker;
    this.perfMarker = options.perfMarker;
    this.perfMarker.willInit();
    this.wizardElement = options.wizardElement;
    this.options = options;
    this.deps = options.deps || {};
    this.audienceCampaignType = options.audienceCampaignType || '';
    this.viewContext = options.viewContext;
    this.currentCampaign = this.viewContext.currentCampaign;
    this.currentLevelTargetInfo = this.options.currentLevelTargetInfo;
    this.isAdImpressions = this.options.isAdImpressions;
    this.estimateRequestFactory = new EstimateRequestFactory({
      currentLevelTargetInfo: this.currentLevelTargetInfo,
    });
    this.i18n = DependencyResolver.get('component/i18n/loader!campaignui/feature/audience-campaign');
    this.i18nErrors = DependencyResolver.get('component/api-errors-campaign/index');
    this.odata = DependencyResolver.get('component/http/channel/odata');
    this.targetBidAdjustment = {};
    this.defaultBidUpdatedByUser = false;
    this.IsSuggestedBidShowedOnUI = false;
    this.showDefaultBidWarning = false;
    this.isDefaultBidCPVWarningRendered = false;
    this.logScenario = options.logScenario;
    this.activityLogger = this.logScenario.createBudgetBids.create();

    const config = DependencyResolver.get('component/config/index');
    this.permissions = config.get('Permissions');
    this.config = config;

    const {
      IsManualCpmEnabled,
      IsManualCpcForVideoAdsEnabled,
      IsAudienceCampaignSwapAdsBudgetAndBidsEnabled,
      IsKPIEstimateForAudienceFeedBasedEnabled,
      IsEnabledDeprecateManualCpcForAudienceCampaign,
      IsHideCpmForFeedbasedCampaginEnabled,
      dynamic: {
        AgeGenderDisclaimer,
      } = {},
    } = this.permissions;

    const bidStrategyType = this.currentCampaign && this.currentCampaign.BiddingScheme && this.currentCampaign.BiddingScheme.Type;
    this.isCpmEnabled = IsManualCpmEnabled;
    this.isManualCpcForVideoAdsEnabled = IsManualCpcForVideoAdsEnabled;
    this.isSwapStepsEnabled = IsAudienceCampaignSwapAdsBudgetAndBidsEnabled &&
      this.audienceCampaignType !== 'shopping';
    this.isHideCpmForFeedbasedCampaginEnabled = IsHideCpmForFeedbasedCampaginEnabled;
    this.IsAIMBidSuggestionEnabled = this.options.audienceCampaignType !== 'shopping' || IsKPIEstimateForAudienceFeedBasedEnabled;
    this.isEnabledDeprecateManualCpcForAudienceCampaign = IsEnabledDeprecateManualCpcForAudienceCampaign;
    this.isShowDisclaimerBannerEnabled = AgeGenderDisclaimer;
    this.isFCapEnabled = bidStrategyType === 'ManualCpm';

    this.CampaignGoalSelectionView = GoalSelectorView;

    this.isVideo = options.isVideo;
    this.isFeedBased = options.audienceCampaignType === 'shopping';
    // eslint-disable-next-line no-nested-ternary
    this.pricingModel = this.isVideo ? 'CPV' : (this.isCpmEnabled || this.isAdImpressions ? 'CPM' : 'CPC');
    this.pricingModels = ['CPC', 'CPV', 'CPM'];
    this.pricingModelToBidTypeString = {
      CPC: 'ManualCpc',
      CPV: 'ManualCpv',
      CPM: 'ManualCpm',
      EnhancedCPC: 'EnhancedCpc',
      MaxConversions: 'MaxConversions',
    };
    this.pricingModelToBidTypeEnum = {
      CPC: BidStrategy.ManualCpc,
      EnhancedCPC: BidStrategy.EnhancedCpc,
      CPV: BidStrategy.ManualCpv,
      CPM: BidStrategy.ManualCpm,
    };
    this.pricingModelAdgroupBidAttributeMapping = {
      CPC: 'SearchBid',
      CPV: 'CpvBid',
      CPM: 'CpmBid',
      EnhancedCPC: 'SearchBid',
      MaxConversions: 'SearchBid',
    };
    this.suggestedBidMapping = {};

    this.initDefaultBidInput();
    this.initAdScheduleView();

    this.errorsView = new AudienceCampaignErrorsView();

    this.frequencyCapping = [{}];

    if (this.currentAdGroup && this.currentAdGroup.FrequencyCapSettings) {
      this.frequencyCapping = this.currentAdGroup.FrequencyCapSettings;
    }

    this.initialFrequencyCapping = _.clone(this.frequencyCapping);

    this.viewmodel = {
      isAdScheduleExpanded: ko.observable(false),
      isBidAdjustmentsExpanded: ko.observable(false),
    };
  }

  /**
   * Get the title of the step section.
   * This is automatically called from the wizard.
   *
   * @readonly
   * @returns {Object} returns object has a property text that is used for the title of the section.
   */
  get title() {
    let title = this.i18n.getString('Audience_Campaign_Settings_BudgetBidsTitle');

    if (this.isSwapStepsEnabled) {
      title = this.i18n.getString('Audience_Campaign_Settings_BudgetBidsTitle_Step3');
    }

    if (this.options.audienceCampaignType === 'shopping') {
      title = this.i18n.getString('Audience_ShoppingCampaign_BudgetBidsTitle_Step3');
    }

    return {
      text: title,
    };
  }

  /**
   * Get the page title of the step section.
   * This is automatically called from the wizard.
   *
   * @readonly
   * @returns {Object} returns object has a property text that is used for the title of the section.
   */
  get pageTitle() {
    let text = this.i18n.getString('BudgetBidsStep_PageTitle');

    if (this.options.audienceCampaignType === 'shopping') {
      text = this.i18n.getString('Audience_ShoppingCampaign_BudgetBidsTitle_Step3_PageTitle');
    }

    return {
      text,
    };
  }

  /**
    * Define events and event handlers for them.
    *
    * @readonly
    * @returns {Object} returns object defining events
    */
  get events() {
    return {
      'click .adschedule-section': 'toggleAdSchedule',
      'click .bid-adjustments-section': 'toggleBidAdjustments',
    };
  }

  toggleAdSchedule() {
    this.$('#adScheduleTargets').toggle();
    this.$('.adschedule-section .bedded-icon-marker').toggleClass('expanderImage expandedImage');
    this.viewmodel.isAdScheduleExpanded(!this.viewmodel.isAdScheduleExpanded());
  }

  toggleBidAdjustments() {
    this.$('#bidAdjustmentTargets').toggle();
    this.$('.bid-adjustments-section .bedded-icon-marker').toggleClass('expanderImage expandedImage');
    this.viewmodel.isBidAdjustmentsExpanded(!this.viewmodel.isBidAdjustmentsExpanded());
  }

  /**
   * Get the actions of the step section.
   * This is automatically called from the wizard.
   *
   * @readonly
   * @returns {Object} returns array that has information about the actions.
   */

  get actions() {
    const actions = [];

    if (this.isSwapStepsEnabled) {
      actions.push({
        name: 'next',
        displayText: this.i18n.getString('Audience_Campaign_Crud_Campaign_Save_Next'),
      });

      actions.push({
        name: 'back',
        displayText: this.i18n.getString('Audience_Campaign_Crud_Campaign_Back_Label'),
      });

      actions.push({
        name: 'done',
        htmlAttributes: {
          class: 'btn-primary',
        },
        enabled: true,
        method: 'saveAndExit',
        displayText: this.i18n.getString('Audience_Campaign_Crud_Campaign_Save_Exit'),
      });
    } else {
      actions.push({
        name: 'save',
        htmlAttributes: {
          class: 'btn-primary',
        },
        displayText: this.i18n.getString('Save'),
      });

      actions.push({
        name: 'back',
        displayText: this.i18n.getString('Audience_Campaign_Crud_Campaign_Back_Label'),
      });
    }

    return actions;
  }

  /**
   * Get the data that is used for the parameter for saving.
   * @param {bool} skipAdScheduling - skip to save the adscheduling data when click back button.
   *
   * @returns {Object} - object representing the data for the campaign to be saved.
   */
  getData(skipAdScheduling) {
    this.campaignId = this.viewContext.currentCampaign.Id;
    this.campaignName = this.viewContext.currentCampaign.Name;
    this.adGroupId = this.viewContext.currentAdGroup.Id;

    const adGroup = {
      Campaign: { Id: this.campaignId },
      Id: this.adGroupId,
      Medium: 'Search',
      // eslint-disable-next-line max-len
      [this.pricingModelAdgroupBidAttributeMapping[this.pricingModel]]: this.defaultBidModel.toJSON().Amount,
      PricingModel: this.pricingModel,
      Status: 'Active',
    };

    const currentSnapshot = this.currentLevelTargetInfo.getSnapshot(this.supportCashbackSettings);

    let targets =
      criterionHelper.compareAndGetCriterionsDelta(this.originalSnapshot, currentSnapshot);

    // Audience Targeting goes to AdGroupAudienceCriterions not AdGroupCriterions
    const audienceTargets = _.filter(targets, target => target.Criterion.Type === 'Audience');

    targets = _.reject(targets, target => target.Criterion.Type === 'Audience');

    adGroup.AdGroupCriterions = this.populateCriterionWithAdGroupIds(targets);
    adGroup.AdGroupAudienceCriterions = this.populateCriterionWithAdGroupIds(audienceTargets);

    const params = {};

    params.Id = this.campaignId;
    params.Name = this.campaignName;
    params.AdGroups = [adGroup];
    params.Budget = this.budgetPanelView.getValues();

    if (this.isAudienceCampaignAutoBiddingV2Enabled) {
      params.BiddingScheme = this.biddingStrategyView.getValues();
    } else {
      params.BiddingScheme = {
        Type: this.pricingModelToBidTypeString[this.pricingModel],
      };
    }

    const dateSettings = this.adScheduleView.getDateSettings();
    _.extend(adGroup, dateSettings);

    if (JSON.stringify(this.initialFrequencyCapping) !== JSON.stringify(this.frequencyCapping)) {
      _.extend(adGroup, { FrequencyCapSettings: [{}] });

      if (this.frequencyCapping) {
        adGroup.FrequencyCapSettings = this.frequencyCapping;
      }
    }

    if (!skipAdScheduling) {
      const scheduling = this.getScheduleInfo();

      // Add Campaign Criterions
      this.populateCriterionCampaignIds(scheduling);
      params.CampaignCriterions = scheduling;
    }

    if (this.goalSelectionView) {
      params.CampaignConversionGoalAssociations =
        this.goalSelectionView.convertToMTFormat(this.campaignId);
    }

    return params;
  }

  isDefaultBidUsed() {
    return this.pricingModel !== 'MaxConversions';
  }

  /**
   * Validate inputs
   *
   * @private
   * @returns {bool} are inputs valid
   */
  validate() {
    this.defaultBidInput.setState({ showError: true });

    return this.budgetPanelView.validate() &&
      (this.isDefaultBidUsed() ? this.defaultBidInput.getState().isValid : true) &&
      this.adScheduleView.validate() &&
      _.every(this.targetBidAdjustment, targetBidAdjustment =>
        targetBidAdjustment.validate());
  }

  /**
   * Update the Campaign with the given setting.
   * @param {bool} skipAdScheduling - skip to save the adscheduling data when click back button.
   * @returns {Promise} - returns promise of returning boolean value indicating
   * if the update process is succesful or not.
   */
  updateCampaign(skipAdScheduling) {
    const jsdata = DependencyResolver.get('component/js-data-campaign/index');
    const params = this.getData(skipAdScheduling);

    this.errorsView.removeErrors();


    if (this.adScheduleView) {
      params.AdScheduleUseSearcherTimeZone =
        _.result(this.adScheduleView, 'getAdScheduleUseSearcherTimeZone');
    }

    return jsdata.Campaign.update(this.campaignId, params, { adapter: 'bulk' }).then((data) => {
      if (_.isFinite(data.Id)) {
        if (this.IsAIMBidSuggestionEnabled) {
          // log for ad insight team to analyze suggestion bid usage.
          const logdata = {
            CampaignId: params.Id,
            AdGroupId: params.AdGroups[0].Id,
            SuggestedBid: this.viewContext.SuggestedBid,
            SearchBid: params.AdGroups[0].SearchBid,
            IsSuggestedBidShowedOnUI: this.IsSuggestedBidShowedOnUI,
            AccountCurrencyCode: this.viewContext.accountCurrencyCode,
          };
          this.activityLogger.trace(logdata);
        }

        const originalCurrentCampaign = this.viewContext.currentCampaign;
        this.viewContext.currentCampaign = {
          CampaignType: originalCurrentCampaign.CampaignType,
          CampaignSubType: originalCurrentCampaign.CampaignSubType,
          CampaignSettings: originalCurrentCampaign.CampaignSettings,
          ...data,
        };

        if (this.permissions.IsPersonalizedOffersEnabled) {
          // the cashback settings in return data is missing
          // we need to add this back
          const cashbackSettings = _.chain(originalCurrentCampaign)
            .result('CampaignCashback')
            .value();
          this.viewContext.currentCampaign.CampaignCashback = cashbackSettings;
        }

        return true;
      }

      return false;
    })
      .catch((response) => {
        if (response && response.entity) {
          const hasErrors = response && !_.isUndefined(response.errors);

          if (hasErrors) {
            // TODO: handle error types
            this.errorsView.setErrors(this.i18nErrors.getBulkApiErrors(response.errors));

            this.activityLogger.trace(getBulkErrorsLogMessage(response.errors));
            _.each(response.errors, (error) => {
              this.activityLogger.signal(error.Error, 'audience budget bid api error');
            });
          } else {
            // Unexpected case. Log Error.
            this.activityLogger.error(getBulkErrorsLogMessage(response.errors));
          }
        } else {
          // Ajax Error
          this.errorsView.setErrors(this.i18nErrors.getODataErrors(response.errors));
          _.each(response.errors, (error) => {
            this.activityLogger.signal(error.Error, 'audience budget bid api error');
          });
        }

        return false;
      })
      .finally(withUiBlock(this.wizardElement, this.i18n.getString('Loading')));
  }

  getEstimatePromise(data) {
    return this.odata.post('Customers()/Accounts()/Default.AudienceEstimationV2', {
      host: 'adinsight.odata.url',
      path: 'AdInsight/V2/',
      data: { request: data },
      customHeader: {
        name: 'x-ms-scenarioname',
        value: this.logScenario.value,
      },
    });
  }

  getCPCRecommendedBidPromise(targetsData) {
    if (_.get(this.viewContext, 'currentCampaign.CampaignType') === 'Audience'
      && _.get(this.viewContext, 'currentCampaign.CampaignSubType') === 'AudienceStatic') {
      const config = DependencyResolver.get('component/config/index');
      const recommendedValueFromContext = config.get(BiddingStrategyValueToRecommendBidKey.ManualCpc);
      const recommendedValue = _.isUndefined(recommendedValueFromContext) || _.isNull(recommendedValueFromContext) ? 3.3 : recommendedValueFromContext;
      return { SuggestedBid: recommendedValue };
    }
    return this.getEstimatePromise(targetsData);
  }

  updateKPIEstimateAsync(e) {
    // Empty data passed in updatePanel function to initialize kpi estimate table
    const estimateDataMock = {
      '@odata.context': 'http://int.adinsight-mt.trafficmanager.net:823/AdInsightMT/V2/oData/$metadata#Microsoft.Advertiser.AdInsight.MT.Interfaces.AIM.AudienceInsight.GetAudienceKPIEstimationV2Response',
      ClicksLostToBid: null,
      ClicksLostToBudget: null,
      Currency: null,
      ErrorCode: 'Success',
      ErrorMessage: null,
      EstAudienceSize: null,
      EstCPC: null,
      EstCTR: null,
      EstClick: null,
      EstCostPerEvent: null,
      EstImpression: null,
      EstSpend: null,
      EstView: null,
      EventsLostToBid: null,
      EventsLostToBudget: null,
      IsMinSuggestedBudget: false,
      RequestFulfilledByHost: 'CO01EAP00004131',
      SuggestedBid: null,
      SuggestedBudget: null,
    };
    this.showDefaultBidWarning = false;
    // if default bid is changed, set this.defaultBidUpdatedByUser = true.
    if (e && e.target && e.target.className && $(e.target).hasClass('Amount-value')) {
      this.defaultBidUpdatedByUser = true;
    }
    if (!this.budgetPanelView.validate() ||
      !this.defaultBidInput.getState().isValid ||
      !this.defaultBidModel.toJSON().Amount ||
      _.isNaN(this.defaultBidModel.toJSON().Amount)
    ) {
      this.updateDefaultBidWarning();
      this.updatePanel(estimateDataMock, true);
      return;
    }
    this.showDefaultBidWarning = this.pricingModel === 'CPV' && this.defaultBidModel.toJSON().Amount > DefaultBidCPVWarningThreshold;
    this.updateDefaultBidWarning();

    const subType = this.viewContext.currentCampaign &&
      this.viewContext.currentCampaign.CampaignSubType;
    const campaignSetting = _.first(_.get(this.viewContext.currentCampaign, 'CampaignSettings')) || {};
    const feedInfo = getFeedInfo(campaignSetting);
    const { UseOptimizedTargeting } = this.viewContext.currentAdGroup;
    // eslint-disable-next-line max-len
    const targetsData = this.estimateRequestFactory.create(this.pricingModelToBidTypeEnum[this.pricingModel], subType, feedInfo, UseOptimizedTargeting);
    targetsData.DailyBudget = this.budgetPanelView.getValues().Amount;
    targetsData.Bid = this.defaultBidModel.toJSON().Amount;

    // Create AudienceEstimation Promise
    if (_.isEmpty(targetsData)) {
      this.updatePanel(estimateDataMock, true);
      return;
    }

    const audienceEstimationUrl = 'Customers()/Accounts()/Default.AudienceKPIEstimationV2';

    this.odata.post(audienceEstimationUrl, {
      host: 'adinsight.odata.url',
      path: 'AdInsight/V2/',
      data: { request: targetsData },
      customHeader: {
        name: 'x-ms-scenarioname',
        value: this.logScenario.value,
      },
    }).then((estimateData) => {
      this.updatePanel(estimateData, estimateData && estimateData.ErrorCode === 'Success');
    }).catch((response) => {
      const hasErrors = response && !_.isUndefined(response.error);

      if (hasErrors) {
        this.updatePanel({ ErrorCode: JSON.stringify(response.error) }, false);
      } else {
        this.updatePanel({ ErrorCode: JSON.stringify(response) }, false);
      }
    }).finally(withUiBlock($('.kpiestimation-result'), this.i18n.getString('Loading')));
  }

  updatePanel(estimateData, reqStatus) {
    this.estimateData = estimateData || {};
    this.estimateData.reqStatus = reqStatus;

    ReactDOM.render(
      <KPIEstimateReact
        i18n={this.i18n}
        pricingModel={this.pricingModel}
        isVideo={this.isVideo}
        {...this.estimateData}
      />,
      this.$('.kpiestimation-result')[0]
    );
  }

  /**
   * Triggers event 'saveAndExit', otherwise it displays an error.
   * @private
   *
   * @returns {Promise} - returns promise of returning boolean value indicating
   * if the save was succesful or not.
   * */
  saveAndExit() {
    if (!this.validate()) {
      this.activityLogger.signal('save and exit: false', 'crud audience budget bid');
      return false;
    }
    return this.updateCampaign(false).then((isSuccessful) => {
      if (!isSuccessful) {
        this.activityLogger.signal(`save and exit: ${isSuccessful}`, 'crud audience budget bid');
        return Promise.reject();
      }

      this.trigger('saveAndExit');

      this.activityLogger.signal('save and exit: true', 'crud audience budget bid');
      return true;
    });
  }

  /**
   * Save the Campaign setting updates.
   *
   * @returns {Promise} - returns promise of returning boolean value indicating
   * if the save was succesful or not.
   */
  save() {
    if (!this.validate()) {
      this.activityLogger.signal('clicked save: false', 'crud audience budget bid');
      return false;
    }

    return this.updateCampaign(false).then((isSuccessful) => {
      this.activityLogger.signal(`clicked save: ${isSuccessful}`, 'crud audience budget bid');

      if (isSuccessful) {
        this.trigger('saveAndExit');
      }
    });
  }

  onFrequencyCappingChange(data) {
    this.frequencyCapping = data.FrequencyCapSettings;
    this.renderFrequencyCapping();
  }

  renderFrequencyCapping() {
    if (this.isFCapEnabled) {
      ReactDOM.render(
        <FrequencyCapping
          i18n={this.deps.i18nNewDesign}
          validationProps={{
            FrequencyCapSettings: this.frequencyCapping,
          }}
          updateValidation={(message, data) => this.onFrequencyCappingChange(data)}
        />,
        this.$('.frequency-capping-container')[0]
      );
    } else {
      ReactDOM.unmountComponentAtNode(this.$('.frequency-capping-container')[0]);
    }
  }

  /**
   * Renders the view
   *
   * @returns {View} returns the view itself
   */
  render() {
    if (this.options && this.options.perfMarker) {
      this.renderMarker = this.perfMarker.createChild('RenderBudgetBid');
      this.renderMarker.willInit();
    }

    // Update pricingModel based on context
    if (this.viewContext.currentAdGroup) {
      this.pricingModel = this.viewContext.currentAdGroup.PricingModel;
    }

    this.$el.html(template(this));

    ko.applyBindings(this.viewmodel, this.el);

    this.renderFrequencyCapping();

    // Delay initialize control as it needs data from other steps
    this.initDailyBudgetView();

    this.$('.budget').append(this.budgetPanelView.render().$el);
    this.$('.default-bid').append(this.defaultBidInput.render().$el);
    this.$('.adschedule-targets').append(this.adScheduleView.render().$el);
    this.$('.errors-container').append(this.errorsView.render().$el);
    if (this.IsAIMBidSuggestionEnabled) {
      this.$('.default-bid').change(this.updateKPIEstimateAsync.bind(this));
      this.$('.budget').change(this.updateKPIEstimateAsync.bind(this));
    }

    this.initTargetBidAdjustmentsAndRender();

    const { CampaignSubType } = this.viewContext.currentCampaign;

    this.isMSANeCPCAutoBiddingEnabled =
      getCampaignType(this.viewContext.currentCampaign) === 'audience' &&
      [
        CampaignSubTypes.AudienceStatic,
        CampaignSubTypes.AudienceFeedBased,
        CampaignSubTypes.AudienceDynamicFeedBased,
      ].includes(CampaignSubType);
    this.isAudienceCampaignAutoBiddingV2Enabled =
      this.permissions.IsAudienceCampaignAutoBiddingV2Enabled &&
      getCampaignType(this.viewContext.currentCampaign) === 'audience' &&
      [
        CampaignSubTypes.AudienceStatic,
        CampaignSubTypes.AudienceFeedBased,
        CampaignSubTypes.AudienceDynamicFeedBased,
      ].includes(CampaignSubType);

    if (this.isAudienceCampaignAutoBiddingV2Enabled) {
      this.biddingStrategyView = new BiddingStrategyView({
        biddingStrategyType: 'EnhancedCPC',
        isInitialize: true,
        isCreation: true,
        campaignType: 'audience',
        activityLogger: this.activityLogger,
        i18nNewDesign: this.options.newI18n,
        campaignLanguage: 'English',
        campaignSubType: CampaignSubType,
      });
      this.biddingStrategyView.viewModel.selectedBidStrategy.subscribe((strategy) => {
        if (strategy === 'EnhancedCpc') {
          strategy = 'EnhancedCPC';
        }
        this.onBidStrategyChanged({ key: strategy });
      });
      this.$('.bidding-strategy__container').empty().html(this.biddingStrategyView.render().$el);
    } else {
      this.initBidStrategy();
    }

    this.perfMarker.done();
    return this;
  }

  /**
   * Update bid input control based on the bid strategy user selects
   * as well as the suggested bid.
   * @param {object} item selected option item
   *
   * @return {undefined}
  */
  onBidStrategyChanged = (item) => {
    this.pricingModel = item.key;
    this.isFCapEnabled = this.pricingModel === 'ManualCpm';
    this.renderFrequencyCapping();
    this.initDefaultBidInput();
    if (this.IsAIMBidSuggestionEnabled && this.suggestedBidMapping[this.pricingModel]) {
      const localized = this.i18n.formatDecimal(this.suggestedBidMapping[this.pricingModel], {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
      this.defaultBidInput.setState({
        value: localized,
      });
      this.updateKPIEstimateAsync();
    }

    // Do not show the default bid on maxConversion
    if (this.isDefaultBidUsed()) {
      this.$('.bid__container').show();
      this.$('.default-bid').html(this.defaultBidInput.render().$el);
    } else {
      this.$('.bid__container').hide();
    }
  };

  /**
   * render Conversion Goal Selection View
   * @param {object} campaign campaign that is use to update goalSelection View
   * @returns {undefined}
   */
  renderConversionGoalSelection = (campaign) => {
    const isSPA = campaign.CampaignSubType === 'ShoppingSponsoredProductAd';
    // Cashback CPS Campaign:
    const isCPS = campaign.CampaignCashback != null &&
      (campaign.CampaignCashback.PersonalizedOffersEnabled === true
        || campaign.CampaignCashback.MonthlyBudget > 0);

    const isSelectorEnabled = !isSPA && !isCPS;
    if (isSelectorEnabled) {
      const jsdata = DependencyResolver.get('component/js-data-campaign/index');
      const state = DependencyResolver.get('component/state/index');
      this.goalSelectionView = new this.CampaignGoalSelectionView({
        i18n: this.i18n,
        pageSize: 10,
        isMultiMode: true,
        isHideSaveBar: true,
        campaign,
        jsdata,
        state,
        activityLogger: this.activityLogger,
      });
      this.$('.conversion-goal-selection').empty().html(this.goalSelectionView.render().el);
    } else {
      this.$('.conversion-goal-section').empty();
    }
  };

  getCampaignPromise = () => {
    const campaign = this.viewContext.currentCampaign;
    const jsdata = DependencyResolver.get('component/js-data-campaign/index');

    const params = {
      queryParameters: {
        entitySet: campaign,
        expand: ['CampaignConversionGoal/Goals'],
      },
      bypassCache: true,
    };

    return jsdata.Campaign.find(Number(campaign.Id), params);
  };

  /**
   * WillShow is called when the view is shown.
   * To support navigating back and forth with the targeting change,
   * we reinitialize the target and bid adjustment.
   *
   * @return {undefined}
   */
  willShow() {
    // While it's ideal where willInit align with the contructor, it is created with the wizard.
    // The perf marker is to measure the user experience perf for the component.
    this.perfMarker.willRender();
    this.toggleTargetsCashbackPercentColumns();
    // refresh suggested bid for all possible bid strategies since user may update
    // targets.
    const subType = _.get(this.viewContext.currentCampaign, 'CampaignSubType');
    const campaignSetting = _.first(_.get(this.viewContext.currentCampaign, 'CampaignSettings')) || {};
    const feedInfo = getFeedInfo(campaignSetting);
    const { UseOptimizedTargeting } = this.viewContext.currentAdGroup;
    const targetsData =
      this.estimateRequestFactory.create(
        this.isEnabledDeprecateManualCpcForAudienceCampaign ? BidStrategy.EnhancedCpc :BidStrategy.ManualCpc,
        subType, feedInfo, UseOptimizedTargeting
      );
    const targetsCPVData =
      this.estimateRequestFactory.create(
        BidStrategy.ManualCpv,
        subType, feedInfo, UseOptimizedTargeting
      );
    const targetsCPMData =
      this.estimateRequestFactory.create(
        BidStrategy.ManualCpm,
        subType, feedInfo, UseOptimizedTargeting
      );
    // Use mock promise for video/non-video case to keep the read logic direct and clean.
    // video case doesn't need Cpc estimation and non-video case doesn't need Cpv.
    const mockEstimateData = { SuggestedBid: 0 };
    const promises = [
      this.getCampaignPromise(),
      this.isVideo ? Promise.resolve(mockEstimateData) : this.getCPCRecommendedBidPromise(targetsData),
      this.isVideo ? this.getEstimatePromise(targetsCPVData) : Promise.resolve(mockEstimateData),
      this.getEstimatePromise(targetsCPMData),
    ];

    Promise
      .all(promises)
      .then(([campaign, cpcEstimateData, cpvEstimateData, cpmEstimateData]) => {
        // duplicate suggested bid mapping as there are currently 2 separate controls
        this.suggestedBidMapping.CPC = cpcEstimateData.SuggestedBid;
        this.suggestedBidMapping.ManualCpc = cpcEstimateData.SuggestedBid;
        this.suggestedBidMapping.CPV = cpvEstimateData.SuggestedBid;
        this.suggestedBidMapping.CPM = cpmEstimateData.SuggestedBid;
        this.suggestedBidMapping.ManualCpm = cpmEstimateData.SuggestedBid;
        this.suggestedBidMapping.EnhancedCPC = cpcEstimateData.SuggestedBid;
        this.suggestedBidMapping.EnhancedCpc = cpcEstimateData.SuggestedBid;

        // save the snapshot to make the diff later.
        this.originalSnapshot = this.currentLevelTargetInfo.getSnapshot();
        if (this.viewContext.currentCampaign && this.viewContext.currentCampaign.Budget) {
          this.budgetPanelView.update({ Amount: this.viewContext.currentCampaign.Budget.Amount });
        }
        if (this.IsAIMBidSuggestionEnabled && this.suggestedBidMapping[this.pricingModel]) {
          if (this.defaultBidUpdatedByUser === false) {
            const localized = this.i18n.formatDecimal(this.suggestedBidMapping[this.pricingModel], {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            });
            this.defaultBidInput.setState({
              value: localized,
            });
            this.IsSuggestedBidShowedOnUI = true;
          } else {
            this.IsSuggestedBidShowedOnUI = false;
          }
          this.updateKPIEstimateAsync();
        } else if (this.IsAIMBidSuggestionEnabled && !this.suggestedBidMapping[this.pricingModel]) {
          if (this.defaultBidUpdatedByUser === false) {
            this.defaultBidInput.setState({
              value: '',
            });
            this.IsSuggestedBidShowedOnUI = true;
          }
          this.updateKPIEstimateAsync();
        }
        this.renderConversionGoalSelection(campaign);
      }).finally(withUiBlock($('.crud-audience-budget-bid'), this.i18n.getString('Loading')));
    if (this.options && this.options.perfMarker && this.renderMarker) {
      this.renderMarker.done();
    }
  }

  toggleTargetsCashbackPercentColumns() {
    if (this.permissions.IsPersonalizedOffersEnabled) {
      const { currentCampaign } = this.viewContext;
      const supportCashbackSettings = shouldSupportCashbackSettings(
        currentCampaign,
        this.permissions
      );
      this.supportCashbackSettings = supportCashbackSettings;

      const cashbackPercent = _.chain(currentCampaign)
        .result('CampaignCashback')
        .result('Percent', null)
        .value();

      _.forEach(this.targetBidAdjustment, (criterionEditor) => {
        if (criterionEditor.resetSupportCashbackSettings) {
          criterionEditor.resetSupportCashbackSettings(supportCashbackSettings, {
            level: 'Campaign',
            value: cashbackPercent,
          });
        }
        this.adScheduleView.toggleCashbackPercentColumns(supportCashbackSettings, {
          level: 'Campaign',
          value: cashbackPercent,
        });
      });
    }
  }

  /**
   * Checks if wizard can go to the next step
   *
   * @returns {Promise} - returns promise of returning boolean value indicating
   * if the save was succesful or not.
   */
  wizardShouldGoNext() {
    if (!this.validate()) {
      this.activityLogger.signal('clicked next: false', 'crud audience budget bid');
      return false;
    }

    return this.updateCampaign(false).then((isSuccessful) => {
      if (!isSuccessful) {
        this.activityLogger.signal(`clicked next: ${isSuccessful}`, 'crud audience budget bid');
        return Promise.reject();
      }

      this.activityLogger.signal('clicked next: true', 'crud audience budget bid');
      return isSuccessful;
    });
  }

  /**
   * wizardShouldGoBack is called when the step goes backi
   * To support navigating back and persist, we save.
   *
   * @return {Promise} - Promise of saving.
   */
  wizardShouldGoBack() {
    if (!this.validate()) {
      this.activityLogger.signal('clicked back: false', 'crud audience budget bid');
      return Promise.resolve(false);
    }

    return this.updateCampaign(true).then((isSuccess) => {
      this.activityLogger.signal(`clicked back: ${isSuccess}`, 'crud audience budget bid');

      return isSuccess;
    });
  }

  initBidStrategy() {
    if (this.isVideo || this.isCpmEnabled) {
      const { CampaignSubType } = this.viewContext.currentCampaign;
      const shouldDeprecateManualCpc = this.isEnabledDeprecateManualCpcForAudienceCampaign &&
        getCampaignType(this.viewContext.currentCampaign) === 'audience' &&
        [
          CampaignSubTypes.AudienceStatic,
          CampaignSubTypes.AudienceFeedBased,
          CampaignSubTypes.AudienceDynamicFeedBased,
        ].includes(CampaignSubType);
      let keys = this.pricingModels.slice();
      const isHideCpmForFeedbasedEnabled = this.isFeedBased
        && this.isHideCpmForFeedbasedCampaginEnabled;
      const pricingModelControls = {
        CPC: {
          disabled: (this.isVideo && !this.isManualCpcForVideoAdsEnabled) || shouldDeprecateManualCpc,
        },
        CPV: {
          disabled: !this.isVideo,
        },
        CPM: {
          disabled: !this.isCpmEnabled || isHideCpmForFeedbasedEnabled,
        },
      };
      this.pricingModels.forEach((pModel) => {
        if (pricingModelControls[pModel].disabled) {
          keys = keys.filter(key => key !== pModel);
        }
      });

      if (this.isMSANeCPCAutoBiddingEnabled) {
        keys.unshift('EnhancedCPC');
        this.pricingModel = 'EnhancedCPC';
      }

      // refresh bid model with latest bid strategy
      // make sure price model don't change after render bid input
      this.onBidStrategyChanged({ key: this.pricingModel });

      ReactDOM.render(
        <BidStrategyReact
          newI18n={this.options.newI18n}
          i18n={this.i18n}
          onStrategyChange={this.onBidStrategyChanged}
          keys={keys}
          defaultSelectedKey={this.pricingModel}
        />,
        this.$('.bid-strategy')[0]
      );
    }
  }

  updateDefaultBidWarning() {
    const defaultBidWarningSelector = '.default-bid-warning';
    if (this.showDefaultBidWarning) {
      if (!this.isDefaultBidCPVWarningRendered) {
        ReactDOM.render(
          <Alert
            message={this.i18n.getString('Audience_Campaign_DefaultBid_CPV_Warning')}
            level="Warning"
          />,
          this.$(defaultBidWarningSelector)[0]
        );
        this.isDefaultBidCPVWarningRendered = true;
      }
      this.$(defaultBidWarningSelector).show();
    } else {
      this.$(defaultBidWarningSelector).hide();
    }
  }

  /**
   * Initialize Target Bid Adjustments view
   *
   * @private
   * @returns {undefined}
   */
  initTargetBidAdjustmentsAndRender() {
    const criterions = cloneDeep(this.currentLevelTargetInfo.getAll());

    // Normalize location type criterions
    const criterionTypesGrouped = _.groupBy(criterions, (criterion) => {
      if (criterion.Criterion.Type === 'Radius' ||
        criterion.Criterion.Type === 'NegativeLocation') {
        return 'Location';
      }

      return criterion.Criterion.Type;
    });

    this.$('.bid-adjustment-targets-container').empty();

    const criterionSettingOptions = {
      currentLevelTargetInfo: this.currentLevelTargetInfo,
      showTargetSelection: false,
      showBidAdjustment: true,
      showTargetOrBid: false,
      activityLogger: this.activityLogger,
    };

    // Initialize and Render CriterionSetting control for each criterion type.
    _.each(criterionTypesGrouped, (criterionTypeGroup) => {
      let criterionType = _.take(criterionTypeGroup).Criterion.Type;

      if (criterionType === 'Radius' || criterionType === 'NegativeLocation') {
        criterionType = 'Location';
      }

      if (criterionType === 'ContextualTarget') {
        return;
      }

      switch (criterionType) {
        case 'CompanyName':
          this.targetBidAdjustment[criterionType] =
            new CompanyNameCriterionSetting(criterionSettingOptions);
          break;

        case 'JobFunction':
          this.targetBidAdjustment[criterionType] =
            new JobFunctionCriterionSetting(criterionSettingOptions);
          break;

        case 'Industry':
          this.targetBidAdjustment[criterionType] =
            new IndustryCriterionSetting(criterionSettingOptions);
          break;

        case 'Age':
          this.targetBidAdjustment[criterionType] =
            new AgeCriterionSetting(criterionSettingOptions);
          break;

        case 'Gender':
          this.targetBidAdjustment[criterionType] =
            new GenderCriterionSetting(criterionSettingOptions);
          break;

        case 'Device':
          this.targetBidAdjustment[criterionType] =
            new DeviceCriterionSetting(criterionSettingOptions);
          break;

        case 'Audience':
          this.targetBidAdjustment[criterionType] =
            new AudienceCriterionSetting(criterionSettingOptions);
          break;

        case 'Location':
          this.targetBidAdjustment[criterionType] =
            new LocationCriterionSetting(criterionSettingOptions);
          break;

        default:
          throw new Error('unsupported type');
      }

      this.$('.bid-adjustment-targets-container').append(this.targetBidAdjustment[criterionType].render().$el);
    }, this);
  }

  /**
   * Initialize Daily Budget view
   *
   * @private
   * @returns {undefined}
   */
  initDailyBudgetView() {
    const BudgetPanelView = DependencyResolver.get('campaignui/feature/budget/view/budget-panel');

    this.budgetPanelView = new BudgetPanelView({
      model: this.viewContext.currentCampaign.Budget,
      activityLogger: this.activityLogger,
    });
  }

  /**
   * Initialize Default Bid input
   *
   * @private
   * @returns {undefined}
   */
  initDefaultBidInput() {
    let currentPricingModel = this.pricingModel;
    // share same bid range with CPC
    if (this.pricingModel === 'EnhancedCPC') {
      currentPricingModel = 'CPC';
    }

    const DefaultBidModel = backboneSchema(getBidSchema({
      bidCeil: _.result(this.config.get(PricingModelToRangeKey[currentPricingModel]), 'CeilingValue'),
      bidFloor: _.result(this.config.get(PricingModelToRangeKey[currentPricingModel]), 'FloorValue'),
    }), this.i18n, ['Amount']);

    this.defaultBidModel = new DefaultBidModel();
    this.defaultBidInput = new InputControl({
      entity: this.defaultBidModel,
      field: 'Amount',
      addonText: this.viewContext.accountCurrencyCode,
      ariaLabelledby: 'defaultBidLabel',
    });
    this.defaultBidInput.on('input-changed', () => {
      this.activityLogger.signal('default bid change', 'crud audience budget bid');
    });
  }

  /**
   * Initialize Ad Schedule view
   *
   * @private
   * @returns {undefined}
   */
  initAdScheduleView() {
    const AdScheduleView = DependencyResolver.get('campaignui/feature/ad-schedule/view/index');

    this.adScheduleView = new AdScheduleView({
      model: {},
      level: 'campaign',
      showDateSettings: 'true',
      activityLogger: this.activityLogger,
    });
  }

  /**
   * Get Ad Schedule info
   *
   * @private
   * @returns {object} scheduling info
   */
  getScheduleInfo() {
    const deletedDayTimeCb = (deletedDayTimeCriterions) => {
      _.each(deletedDayTimeCriterions, (criterion) => {
        criterion.Status = 'Deleted';
        criterion.Campaign = {
          Id: this.campaignId,
        };
      });
    };
    const scheduling = this.adScheduleView.getValues(deletedDayTimeCb);

    return scheduling;
  }

  /**
   * Populate Campaign Criterion
   *
   * @private
   * @param {object} criterions criterions to populate
   * @returns {undefined}
   */
  populateCriterionCampaignIds(criterions) {
    _.each(criterions, (criterion) => {
      criterion.Status = _.isEmpty(criterion.Status) ? 'Active' : criterion.Status;
      criterion.Campaign = {
        Id: this.campaignId,
      };
    }, this);
  }

  /**
   * Populate AdGroup Criterion
   *
   * @private
   * @param {object} criterions - criterions to populate
   * @returns {object} - filtered criterions with AdGroupId
   */
  populateCriterionWithAdGroupIds(criterions) {
    _.each(criterions, (criterion) => {
      criterion.AdGroup = {
        Id: this.adGroupId,
      };
    }, this);

    return criterions;
  }

  remove() {
    _.each(this.targetBidAdjustment, (view) => {
      view.remove();
    });
    if (this.budgetPanelView) {
      this.budgetPanelView.remove();
    }
    if (this.goalSelectionView) {
      this.goalSelectionView.remove();
    }
    this.defaultBidInput.remove();
    this.adScheduleView.remove();
    this.errorsView.remove();
    super.remove();
  }
}
